import React, {useEffect, useState} from "react";
import {Route, Routes, useNavigate} from "react-router-dom";
import PrivateMeet from "./meet";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Events from "./pages/Events/Events";

const App = () => {
	const navigate = useNavigate();
	const [isPublic, setIsPublic] = useState(false);
	const [publicMeetId, setPublicMeetId] = useState("");

	const isAuthenticated = localStorage.getItem("auth");
	useEffect(() => {
		setIsPublic(false);
		setPublicMeetId("");
		if (!isAuthenticated) navigate("/login");
	}, []);

	return (
		<>
			<Routes>
				<Route path='/login' element={<Login />} />
				<Route path='/register' element={<Register />} />
				<Route path='/' element={<Home />} />
				<Route
					path='/meet'
					element={
						<PrivateMeet
							isPublic={isPublic}
							publicMeetId={publicMeetId}
							setPublicMeetId={setPublicMeetId}
						/>
					}
				/>
				<Route
					path='/events'
					element={<Events setIsPublic={setIsPublic} />}
					setPublicMeetId={setPublicMeetId}
				/>
			</Routes>
		</>
	);
};

export default App;
